import { delay } from '@shared/utils/async';
import { HttpEndpoint } from '../httpEndpoints';
import { generateUUID } from '@shared/utils/uuid';
import {
    MyBookingCredentials,
    MyBookingCredentialsEndpoint as MyBookingCredentialsEndpointModel,
} from './myBookingCredentials.interfaces';

export class MyBookingCredentialsEndpoint
    extends HttpEndpoint
    implements MyBookingCredentialsEndpointModel
{
    constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public Init(id: string, password: string): Promise<MyBookingCredentials> {
        return this.get('mvc/MyBookingPage/Init').then((r: any) => ({
            id,
            password,
            sessionData: r.SessionData,
            sessionId: r.SessionId,
            isLoggedIn: r.IsLoggedIn,
        }));
    }
}

export class FakeMyBookingCredentialsEndpoint {
    public async Init(): Promise<MyBookingCredentials> {
        await delay(500);
        return {
            id: 'ABC123',
            password: '345XYZ',
            sessionId: generateUUID(),
            sessionData: generateUUID(),
            isLoggedIn: false, //TODO
        };
    }
}
